
import styled from 'styled-components';

export const GeoDialogListBox = styled.div`
    position: relative;
    margin-top: 40px;
    &:before{
        content:"";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: -28px;
        border-left: 1px dotted ${({theme}) => theme.colors.textLight};
    }
`